import React from 'react';
import BedHistoryModal from './BedHistoryModal';

const BedCard = ({ bed, sectors, statuses, onStatusChange }) => {
  const sector = sectors.find(s => s.id === bed.sectorId) || { name: 'Desconhecido' };
  const status = statuses.find(s => s.id === bed.statusId) || { name: 'Desconhecido', color: '#ccc' };

  return (
    <div className="card mb-3" style={{ borderLeft: `5px solid ${status.color}` }}>
      <div className="card-body">
        <h5 className="card-title">{bed.number}</h5>
        <p className="card-text">
          <strong>Setor:</strong> {sector?.name}<br />
          <strong>Status:</strong> <span style={{ color: status.color }}>{status.name}</span>
        </p>
        <select
          className="form-select mb-2"
          value={bed.statusId}
          onChange={(e) => onStatusChange(bed.id, parseInt(e.target.value))}
        >
          {statuses.map(status => (
            <option key={status.id} value={status.id}>{status.name}</option>
          ))}
        </select>
        <button
          className="btn btn-sm btn-outline-secondary"
          data-bs-toggle="modal"
          data-bs-target={`#historyModal${bed.id}`}
        >
          <i className="bi bi-clock-history me-1"></i>
          Histórico
        </button>
      </div>
      <BedHistoryModal bedId={bed.id} bedNumber={bed.number} />
    </div>
  );
};

export default BedCard;
